<template>
  <a
    class="rs-quote-listing__card"
    :href="post.permalink"
    :lang="post.lang"
    :hreflang="post.lang"
    :dir="post.lang_dir"
  >
    <blockquote class="rs-quote-listing__card__blockquote">
      <span v-html="post.quote_text"></span>
      <cite v-html="post.quote_place_and_date" />
    </blockquote>

    <svg
      class="rs-quote-listing__card__arrow"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      :style="{ transform: `rotate(${post.lang_dir === 'rtl' ? 180 : 0}deg)` }"
    >
      <g transform="translate(-625 -839)">
        <path
          d="M6.524-5.292l-4.8-4.52,4.8-4.54h2.1L3.811-9.812l4.815,4.52Z"
          transform="translate(641.209 839.678) rotate(180)"
          fill="#652981"
        />
        <path
          d="M10.5,1A9.5,9.5,0,1,0,20,10.5,9.511,9.511,0,0,0,10.5,1m0-1A10.5,10.5,0,1,1,0,10.5,10.5,10.5,0,0,1,10.5,0Z"
          transform="translate(625 839)"
          fill="#652981"
        />
      </g>
    </svg>
  </a>
</template>

<script>
export default {
  props: {
    baseURL: String,
    post: Object,
  },
};
</script>
